import React from "react";
import {
  Row,
  Col,
  Flex,
  Statistic,
  Table,
  Tag,
  Typography,
  Card,
  Space,
  Button,
  Grid, // <- added
} from "antd";
import { useNavigate } from "react-router-dom"; // <- added
import { HomeOutlined, CaretLeftOutlined } from "@ant-design/icons"; // <- added
const { Title, Text } = Typography;

// ── Component ──────────────────────────────────────────
const Dashboard = () => {
  const navigate = useNavigate(); // <- added
  const screens = Grid.useBreakpoint(); // <- added
  // screens.sm è true quando la viewport è >= sm; regola la logica come preferisci

  return (
    <Space direction="vertical" size={24} style={{ width: "100%" }}>
      <div
        style={{
          background: "white",
          minHeight: "100vh",
        }}
      >
        <div
          style={{
            background: "linear-gradient(135deg, #f9b27fff, #ff8c00)",
            height: "100px",
            maxHeight: "100px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 20px rgba(255, 106, 0, 0.3)",
            position: "relative",
          }}
        >
          <Button
            type="text"
            onClick={() => navigate("/PappaTime")}
            icon={<CaretLeftOutlined />}
            aria-label="Home"
            style={{
              position: "absolute",
              left: 16,
              top: "50%",
              transform: "translateY(-50%)",
              color: "#fff",
              fontSize: 20,
            }}
          >
            Back
          </Button>
          <div style={{ alignItems: "center", justifyContent: "center" }}>
            <Title
              level={1}
              style={{
                color: "#fff",
                letterSpacing: "-0.4px",
              }}
            >
              Acqua Facile
            </Title>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            //textAlign: "center",
            padding: "40px 16px",
            maxWidth: 1100,
            margin: "0 auto",
          }}
        >
          <div style={{ maxWidth: 760, width: "100%" }}>
            <Text
              type="secondary"
              style={{
                fontSize: 20,
                marginBottom: 12,
                color: "#333",
                textAlign: "inherit",
              }}
            >
              In questa sezione troverete alcune informazioni sull’idratazione.
              In letteratura alcuni studi cercano di capire le differenze tra
              liquidi liberi e modificati. Le bevande addensate possono saziare
              di meno la sete o risultare meno gradevoli al palato. Per evitare
              che il vostro/a bimbo/a bevano poco durante il giorno, abbiamo
              pensato a dei consigli per facilitare il momento dell’idratazione,
              senza rinunciare alla sicurezza.
              <br />
              <br />
              <span style={{ fontWeight: "bold" }}>
                {" "}
                “Anche l’occhio vuole la sua parte”:
              </span>{" "}
              Scegliete insieme al bambino/a un bicchiere che gli piaccia, molto
              colorato o con disegni. Sono piccoli dettagli ma possono rendere
              più divertente e accattivante il momento dell’idratazione, nonché
              la richiesta di bere. <br />
              <br />
              <span style={{ fontWeight: "bold" }}>
                “Un tocco di colore”:
              </span>{" "}
              Utilizzare degli sciroppi colorati al gusto frutta, può rendere
              più gradevole il gusto della bevanda. In alternativa, è possibile
              ricorrere a succhi o estratti di frutta e verdura, da addensare
              anch’essi secondo le indicazioni. In caso di diabete o indicazioni
              nutrizionali specifiche, è sempre consigliato affidarsi allo
              specialista di riferimento.
              <br />
              <br />
              <span style={{ fontWeight: "bold" }}>“Un pizzico di…”:</span> In
              alternativa a sciroppi e succhi di frutta, si può aromatizzare la
              bevanda, grazie all’utilizzo di tisane e infusi profumati.
              <br />
              <br />
              <span style={{ fontWeight: "bold" }}>
                {" "}
                “Spazio ai pinguini”:
              </span>{" "}
              Il freddo può essere percepito maggiormente a livello sensoriale
              quindi un suggerimento è quindi quello di preparare delle granite
              o mantenere le bevande fresche, soddisfando così anche il
              desiderio di sete. <br />
              <br />
              <span style={{ fontWeight: "bold" }}>
                {" "}
                “L’igiene prima di tutto”:
              </span>{" "}
              Un’attenta cura orale consente di ridurre la carica batterica in
              modo efficace, quindi anche il rischio di polmonite ab ingestis.
              Pulire adeguatamente il cavo orale, evita che eventuali ristagni
              vengano aspirati e attiva i recettori sensoriali all’interno della
              bocca. In questo modo si favorisce la reattività nel momento della
              deglutizione. <br />
              <br />
              <span style={{ fontWeight: "bold" }}>Bibliografia:</span>
            </Text>

            <Text
              type="secondary"
              style={{
                fontSize: 16,
                marginBottom: 12,
                color: "#333",
                textAlign: "inherit",
              }}
            >
              <br />
              -Pico-Munyoz, R., (2023, 25 Aprile) Thirstiness, body hydration
              and thickened water: A study about their relationship. Disponibile
              9 Settembre, 2023, da
              https://www.sciencedirect.com/science/article/pii/S0950329323001829
              <br />
              -Ebihara, S., (2010, 1 Settembre) Sensory Stimulation to Improve
              Swallowing Reflex and Prevent Aspiration Pneumonia in Elderly
              Dysphagic People. Disponibile 14 Dicembre, 2010, da
              https://www.sciencedirect.com/science/article/pii/S134786131930773X
              <br />
              -Ebihara, S., (2021, 29 Agosto) A Systematic Review of Reported
              Methods of Stimulating Swallowing Function and their
              Classification. Disponibile 28 Gennaio, 2022, da
              https://www.researchgate.net/publication/358179983_A_Systematic_Review_of_Reported_Methods_of_Stimulating_Swallowing_Function_and_their_Classification
              <br />
              -K Teismann, I., (2009, 11 Febbraio) Tactile thermal oral
              stimulation increases the cortical representation of swallowing.
              Disponibile 30 Giugno, 2009, da
              http://www.biomedcentral.com/1471-2202/10/71
              <br />
              -Nishizawa, T., Pilot study for risk assessment of aspiration
              pneumonia based on oral bacteria levels and serum biomarkers.
              Disponibile 2 Settembre, 2019, da
              https://doi.org/10.1186/s12879-019-4327-2
              <br />- Chang, W., (2025, 20 Gennaio) Endoscopic surveillance of
              poor oral hygiene in vulnerable patients at pneumonia risk.
              Disponibile 24 Maggio 2025, da
              https://doi.org/10.1007/s00784-025-06392-4
            </Text>
          </div>
        </div>
      </div>
    </Space>
  );
};

export default Dashboard;
